import React, { useEffect } from 'react';

import { useConfluenceAnalyticsEvents } from '@confluence/analytics/entry-points/useConfluenceAnalyticsEvents.ts';

import { SearchAcrossToolsItem } from '../components/SearchAcrossToolsItem.tsx';
import { SetupConnectorModal } from '../components/SetupConnectorModal.tsx';
import { useConnectorPromoConfig } from '../hooks/useConnectorPromoConfig.ts';

/**
 * Self-contained surface component for the sidebar.
 * Internally calls useConnectorPromoConfig and renders the SearchAcrossToolsItem.
 * When the user clicks "Setup" on a connector, a modal is lazy-loaded and shown.
 */
export function ConnectorPromoSidebar() {
	const config = useConnectorPromoConfig();
	const { createEvent } = useConfluenceAnalyticsEvents();

	useEffect(() => {
		if (!config.shouldShowSidebarItem) {
			return;
		}
		createEvent({
			type: 'sendTrackEvent',
			data: {
				source: 'ConnectorPromoSidebar',
				action: 'viewed',
				actionSubject: 'connectorPromo',
				attributes: {
					promoVariant: 'sidebarItem',
					container: 'ConnectorPromoSidebar',
				},
			},
		}).fire();
	}, [config.shouldShowSidebarItem, createEvent]);

	if (!config.shouldShowSidebarItem) {
		return null;
	}

	return (
		<>
			<SearchAcrossToolsItem
				recommendedConnectors={config.recommendedConnectors}
				onSetupConnector={config.onSetupConnector}
				onDismiss={() => config.onDismissPromo('sidebar')}
				shouldShowSpotlight={config.shouldShowSpotlight}
				onDismissSpotlight={config.onDismissSpotlight}
			/>
			{config.activeConnectorKey && (
				<SetupConnectorModal connectorKey={config.activeConnectorKey} onClose={config.closeModal} />
			)}
		</>
	);
}
